import { createSlice } from '@reduxjs/toolkit'
import { AssetStatusDetailsList } from 'app/types/types'

const initialState: AssetStatusDetailsList = {
  location: {
    label: 'Location',
    count: 0,
    errorCount: 0,
    errorList: []
  },
  elevator: {
    label: 'Elevator',
    count: 0,
    errorCount: 0,
    errorList: []
  },
  escalator: {
    label: 'Escalator',
    count: 0,
    errorCount: 0,
    errorList: []
  }
}

const assetStatusDetailsSlice = createSlice({
  name: 'assetStatusDetails',
  initialState,
  reducers: {
    setAssetStatusDetails: (state, action) => {
      state.location = action.payload.location
      state.escalator = action.payload.escalator
      state.elevator = action.payload.elevator
    },
    resetAssetStatusDetails: state => {
      state.location = initialState.location
      state.elevator = initialState.elevator
      state.escalator = initialState.escalator
    }
  }
})

export const { setAssetStatusDetails, resetAssetStatusDetails } = assetStatusDetailsSlice.actions

export default assetStatusDetailsSlice.reducer
